import { isEmpty, isString } from "lodash-es";
import { ensure, TType } from "types";

import { IURLSearchParams, urlSearchParamsConfig } from "@/core/url";
import { IUser } from "@/data/users";
import { IWithRoutePropsProps } from "@/infrastructure/Route";

import { ITaskOriginService, TaskPriority, TaskType } from "./types";

export interface ITasksRouteParams {
  taskId: number;
}

export interface ITasksRouteProps extends IWithRoutePropsProps<ITasksRouteParams> {}

export const configTasksPatchParamsType: TType<ITasksRouteParams> = {
  taskId: v => (isString(v) ? parseInt(v, 10) : NaN),
};

export const tasksPatchParamsType = ensure(configTasksPatchParamsType);

export interface ITasksURLFilter {
  query?: string;
  types?: TaskType[];
  assignees?: Array<Partial<IUser>>;
  priorities?: TaskPriority[];
  withAssignee?: boolean;
  originServices?: ITaskOriginService[];
}

const configTasksURLFilterType: TType<ITasksURLFilter> = {
  query: v => (v ? v : undefined),
  types: v => (!isEmpty(v) ? v : undefined),
  assignees: v => (!isEmpty(v) ? v : undefined),
  priorities: v => (!isEmpty(v) ? v : undefined),
  withAssignee: v => v,
  originServices: v => (!isEmpty(v) ? v : undefined),
};

export const tasksURLFilterType = ensure(configTasksURLFilterType);

export interface ITasksListSearchParams extends IURLSearchParams {
  filtersConfig: ITasksURLFilter;
}

const configTasksListSearchParams: TType<ITasksListSearchParams> = {
  ...urlSearchParamsConfig,
  filtersConfig: tasksURLFilterType,
};

export const tasksListSearchParamsType = ensure(configTasksListSearchParams);
